import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { remove } from './../../../utils/Storage'
import SideNav, { NavIcon, NavItem} from '@trendmicro/react-sidenav';

import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import Dropdown from 'react-bootstrap/Dropdown'
import Form from 'react-bootstrap/Form'

import Logo from './../../../assets/img/ares-logo.png'
import { GrClose } from 'react-icons/gr'
import { GiHamburgerMenu } from 'react-icons/gi'
import { BsThreeDotsVertical } from 'react-icons/bs'
import { useAuth } from '../../../providers/auth';
import { MdDirectionsCar, MdPersonAdd, MdSearch, MdSystemUpdate, MdTimelapse, MdStore, MdPerson } from 'react-icons/md';


import './NavBar.css'
import SideNavPage from '../SideBar/SideBar'
import SideBar from '../SideBar/SideBar'
import { AiOutlineClose } from 'react-icons/ai'

export default function AresNavBar(options) {
    const [showMenu, setShowMenu] = useState(false)
    const history = useHistory();
    const { user } = useAuth();

    const handleMenuOpen = (e) => {
        setShowMenu(true);
    }

    const handleMenuClose = (e) => {
        e.preventDefault();
        setShowMenu(false)
    }

    return (
        <div className="AresNavBar">
            <div className={`navbar-overlay ${showMenu ? 'open' : ''}`}>
                <div className="close-container">
                    <a href="#" onClick={handleMenuClose}>
                        <AiOutlineClose size='2.5em' style={{ color: 'white' }} />
                    </a>
                </div>
                {navLinks()}
            </div>
            <Navbar expand="lg">
                {navLogo()}
                <button id="menu-button" className="btn" type="button">
                    <GiHamburgerMenu onClick={handleMenuOpen} />
                </button>
                <Navbar.Collapse id="basic-navbar-nav">
                    {navLinks()}
                </Navbar.Collapse>
            </Navbar>
        </div>
    )

    function navLogo() {
        return (
            <Navbar.Brand href="/devices">
                <div className="container-logo">
                    <img src={Logo} alt="Ares Logo" />
                </div>
            </Navbar.Brand>
        )
    }

    function navLinks() {
        return (
            <Nav className="mr-auto">
                <div style={{ overflowY: 'scroll', textAlign: 'center', marginTop: '3rem', width: '100%' }}>
                        
                    <Nav.Link href="/profile">Perfil</Nav.Link>

                    <Nav.Link href="/my-devices">Meus dispositivos</Nav.Link>
                    {user.profile._id == "6086f50d46258e47f28ec9d5" &&
                        // Viagens
                        <Nav.Link href="/directions">Viagens</Nav.Link>
                    }
                    {user.profile._id != '6086f578b3f7ce0def82f243' && user.profile._id != '6089aebd882b6b8c415c4de5' ?
                        // Dispositivos
                        <Nav.Link href="/client-devices">Dispositivos</Nav.Link>
                        : null
                    }
                    {user.profile._id == "6086f50d46258e47f28ec9d5" ?
                        // Empresas
                        <Nav.Link href="/enterprises">Empresas</Nav.Link>
                        : null
                    }
                    {user.profile._id == "6086f50d46258e47f28ec9d5" || user.profile._id == '60846a923c0c98d2837f2e42' ?
                        // Usuários
                        <Nav.Link href="/select-user">Usuários</Nav.Link> : null
                    }
                    {user.profile._id == "6086f50d46258e47f28ec9d5" &&
                        // Rastrear Viagem
                        <Nav.Link href="/localizator">Rastrear Viagem</Nav.Link>
                    }
                    {user.profile._id == "6086f50d46258e47f28ec9d5" &&
                        // Firmware
                        <Nav.Link href="/firmware">Firmwares</Nav.Link>
                    }
                    <Nav.Link href="/settings">Configurações</Nav.Link>
                    <Nav.Link onClick={e => { logout(e) }}>Sair</Nav.Link>
                </div>
            </Nav>
        )
    }

    function logout(e) {
        e.preventDefault();
        remove('token')
        remove('user')
        history.push('/');
    }
}
